import React, { useEffect, useState } from 'react';
import { Alert, Drawer, Spin, Timeline, Typography } from 'antd';
import dayjs from 'dayjs';
import { getPointHistory } from '../../services/api';
import { getApiError } from '../../utils/apiError';
import { Question } from './checklistTypes';

const { Text } = Typography;

const LABEL: { [kind: string]: { text: string; colour: string } } = {
  FLAGGED: { text: 'Flagged by the reviewer', colour: 'orange' },
  FLAG_EDITED: { text: 'Reviewer changed the flag note', colour: 'orange' },
  REFLAGGED: { text: 'Flagged again by the reviewer', colour: 'orange' },
  WITHDRAWN: { text: 'Reviewer withdrew the flag', colour: 'gray' },
  ACCEPTED: { text: 'Accepted by the reviewer', colour: 'green' },
  REPLIED: { text: 'Auditor replied and marked it addressed', colour: 'blue' },
  UNDONE: { text: 'Auditor took back "addressed"', colour: 'gray' },
  ANSWER_CHANGED: { text: 'Auditor changed the answer', colour: 'blue' },
  NC_SAVED: { text: 'Auditor saved the NC', colour: 'blue' },
  EVIDENCE_ADDED: { text: 'Auditor added evidence', colour: 'blue' },
  EVIDENCE_REMOVED: { text: 'Auditor removed evidence', colour: 'blue' },
  REVIEWER_CHANGE: { text: 'Reviewer changed the answer or NC level', colour: 'red' },
};

interface Props {
  visitId: string;
  question: Question | null;
  onClose: () => void;
}

const HistoryDrawer: React.FC<Props> = ({ visitId, question, onClose }) => {
  const [events, setEvents] = useState<any[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!question) return;
    setEvents(null);
    setError('');
    getPointHistory(visitId, question.id)
      .then((res) => setEvents(res.data.events))
      .catch((err) => setError(getApiError(err, 'Could not load the history.')));
  }, [question, visitId]);

  return (
    <Drawer title={question ? `History of ${question.code}` : ''} open={!!question} onClose={onClose} size={520} destroyOnHidden>
      {question && <Alert type="info" showIcon message={question.text} style={{ marginBottom: 16 }} />}
      {error && <Alert type="error" showIcon message={error} />}
      {!events && !error && <Spin />}
      {events && events.length === 0 && <Text type="secondary">Nothing recorded yet.</Text>}
      {events && events.length > 0 && (
        <Timeline
          items={events.map((e) => ({
            color: (LABEL[e.kind] || { colour: 'gray' }).colour,
            content: (
              <div>
                <Text strong>{(LABEL[e.kind] || { text: e.kind }).text}</Text>
                <div><Text type="secondary">{e.by} · {dayjs(e.at).format('DD MMM YYYY HH:mm')}</Text></div>
                {e.text && <div style={{ whiteSpace: 'pre-wrap' }}>{e.text}</div>}
              </div>
            ),
          }))}
        />
      )}
    </Drawer>
  );
};

export default HistoryDrawer;
